import { ref, onMounted } from 'vue';
import { useFetch } from '@apparatix/composables';
export const useImpersonation = (realUser) => {
    const { get, post } = useFetch();
    const users = ref([]);
    const isLoading = ref(false);
    const hasPermission = realUser.isAdmin || realUser.isTechnoGeek;
    const impersonateUser = async (user) => {
        if (!hasPermission)
            return false;
        try {
            const result = await post('/masquerade', user);
            if (result.success) {
                window.location.reload();
                return true;
            }
            return false;
        }
        catch (err) {
            console.error(err);
            return false;
        }
    };
    const disableImpersonation = async () => {
        if (!hasPermission)
            return;
        try {
            post('/masquerade/disable', {}).then(() => window.location.reload());
        }
        catch (err) {
            console.warn(err);
        }
    };
    onMounted(() => {
        if (!hasPermission)
            return;
        isLoading.value = true;
        get('/masquerade').then((userList) => {
            if (userList && userList.length) {
                users.value = userList;
                isLoading.value = false;
            }
        });
    });
    return {
        isLoading,
        users,
        impersonateUser,
        disableImpersonation,
        hasPermission,
    };
};
